module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header-modal', {
    staticClass: "fade",
    attrs: {
      "id": "message-modal"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalLabel"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "false"
    }
  })]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    slot: "footer"
  }, [_vm._v("OK")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-551b842c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/MessageModal.vue
// module id = 336
// module chunks = 1